module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B3LZRTG.f7f67f7a.jpg";